// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import consumer from "./channels/consumer"

// ActionCable consumer (globally available)
window.consumer = consumer
